import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';

class ProfilEcritureAffectationResultatRecette extends BaseProfilEcritureRecette {
	constructor() {
		super();
		this.code = PROFIL_ECRITURE.RECETTE.AFFECTATION_RESULTAT;
		this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.RECETTE.INVESTISSEMENT;
		this.typePiece = TYPE_PIECE.RECETTE.ORDRE_MIXTE;
		this.imputation.articles = ['106'];
		this.codesProduitLocal = ['305'];
		this.panels = [...this.panels, new CompteDeTiersPanel(), new CovidPanel()];
	}
}

export default ProfilEcritureAffectationResultatRecette;
